module.exports = __webpack_public_path__ + "img/log-out.2c61bccd.svg";